import { Uchain } from "../redux/api/agent";
import { call, put, takeEvery } from "redux-saga/effects";
import { sagaActions } from "./sagaActions";
import { toast } from "react-toastify";
import {
  initiateLoading,
  fetchBucketListSuccess,
  fetchBucketListFailure,
  manageBucketSuccess,
  manageBucketFailure,
  insertDMSTruckAuditSuccess,
  insertDMSTruckAuditFailure,
  getDMSTruckAuditByControlSuccess,
  getDMSTruckAuditByControlFailure,
  clearDMSTruckAudit,
} from "../redux/reducers/reducerSlices/DmsBucketReducer";
import { showAlert } from "../App/Assests/Utility";

function* insertDMSTruckAuditHandler(action) {
  try {
    yield put(initiateLoading());
    const response = yield call(Uchain.insertDMSTruckAudit, action.payload);
    yield put(insertDMSTruckAuditSuccess(response));
  } catch (error) {
    yield put(insertDMSTruckAuditFailure(error));
  }
}
function* fetchBucketListHandler(action) {
  try {
    yield put(initiateLoading());
    const response = yield call(Uchain.manageDmsBucket, action.payload);
    yield put(fetchBucketListSuccess(response));
  } catch (error) {
    yield put(fetchBucketListFailure(error));
  }
}

function* manageBucketHandler(action) {
  try {
    yield put(initiateLoading());
    const response = yield call(Uchain.manageDmsBucket, action.payload);
    yield put(manageBucketSuccess(response));

    // Refresh the list after successful enable/disable/delete operations
    if (
      action.payload.type === "enable" ||
      action.payload.type === "disable" ||
      action.payload.type === "delete"
    ) {
      showAlert(toast.TYPE.SUCCESS, response.message, "light-mode");

      yield put({
        type: sagaActions.FETCH_DMS_BUCKET_LIST,
        payload: { type: "get" },
      });
    }
  } catch (error) {
    // Extract error message safely
    let errorMessage = "Operation failed";

    if (typeof error === "string") {
      errorMessage = error;
    } else if (error && typeof error === "object") {
      // Handle Axios error structure
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      } else if (error.data && error.data.message) {
        errorMessage = error.data.message;
      }
    }

    // Don't show alert here - let the component handle it via useEffect
    yield put(manageBucketFailure(errorMessage));
  }
}

export function* fetchDmsBucketListWatcher() {
  yield takeEvery(sagaActions.FETCH_DMS_BUCKET_LIST, fetchBucketListHandler);
}

export function* manageDmsBucketWatcher() {
  yield takeEvery(sagaActions.MANAGE_DMS_BUCKET, manageBucketHandler);
}

export function* insertDMSTruckAudit() {
  yield takeEvery(
    sagaActions.INSERT_DMS_TRUCK_AUDIT,
    insertDMSTruckAuditHandler,
  );
}

export function* clearDMSTruckAuditInSaga() {
  yield takeEvery(sagaActions.CLEAR_DMS_TRUCK_AUDIT, clearDMSTruckAuditSaga);
}

export function* getDMSTruckAuditByControl() {
  yield takeEvery(
    sagaActions.GET_DMS_TRUCK_AUDIT_BY_CONTROL,
    getDMSTruckAuditByControlHandler,
  );
}

function* getDMSTruckAuditByControlHandler(action) {
  try {
    yield put(initiateLoading());
    const response = yield call(
      Uchain.getDMSTruckAuditByControl,
      action.payload,
    );
    yield put(getDMSTruckAuditByControlSuccess(response));
  } catch (error) {
    yield put(getDMSTruckAuditByControlFailure(error));
  }
}

function* clearDMSTruckAuditSaga(data) {
  try {
    yield put(clearDMSTruckAudit([]));
  } catch (error) {
    yield put(clearDMSTruckAudit([]));
  }
}
